<div class="dashboard-wrapper">
  <h1 class="main-title">Incidencias</h1>

  <div class="tabs-container">
    <a
      routerLink="./operativas"
      routerLinkActive="active-operativas"
      class="tab-btn btn-operativas"
    >
      <div class="tab-content">
        <mat-icon>folder</mat-icon> Incidencias Operativas
      </div>
    </a>

    <a
      routerLink="./pre-operativas"
      routerLinkActive="active-pre-operativas"
      class="tab-btn btn-pre-operativas"
    >
      <div class="tab-content">
        <mat-icon>folder_open</mat-icon> Incidencias Pre-Operativas
      </div>
    </a>

    <a
      routerLink="./revision-ac"
      routerLinkActive="active-revision"
      class="tab-btn btn-revision"
    >
      <div class="tab-content">
        <mat-icon>folder_shared</mat-icon> Revisión Atención al Cliente
      </div>
    </a>
  </div>

  <div class="content-wrapper">
    <div *ngIf="!outlet.isActivated" class="select-prompt">
      Por favor, seleccione un tipo de incidencia.
    </div>
    <router-outlet #outlet="outlet"></router-outlet>
  </div>
</div>
